import Commander from './Commander';
import {CONFIG_PARAMS} from "../framework/src/system/SystemConfig";
import {STATES} from "../framework/src/states/states";
export default class States {

    constructor(commander) {

        this.commander = commander;    }


    move(data){
        //console.log(data);
        let reel = data.reel;
        if (this.StickingWild.jokers[reel.getId()].hide) {
            this.StickingWild.jokers[reel.getId()].y += data.shift;
        }
    }
    
    accUp(data) {
        let reel = data.reel;

        let counter = 0;
        for(let r of this.slots.getReels()) {
            if (r.data.joker || r.data.redJoker)
                counter++;
            if (r.getId() === reel.getId()) {  /// Skipping wild reels delay on respin
                this.slots.reels.setSymbolsToStoppingDelay(reel.getId(), (reel.getId() - counter + 1) * 4);
            }
        }
    }

    accDown(data) {

    }

    spin(data) {
        let reel = data.reel;
        for (let symbol of reel.getSpinSymbols()) {
            Commander.blurSymbol(symbol);
        }
        if (this.StickingWild.jokers[reel.getId()].hide) {
            Commander.blurSymbol(this.StickingWild.jokers[reel.getId()].children[3]);
        }
        for (let symbol of reel.getResSymbolsTmp()) {
            Commander.blurSymbol(symbol);
        }
    }

    stopping(data) {
    }

    brakeDown(data) {
        let reel = data.reel;
        if (reel.getId() === 3) {
            this.states.setState(STATES.FORCESPIN);
        }

        for (let symbol of reel.getSpinSymbols()) {
            Commander.unblurSymbol(symbol);
        }

        for (let symbol of reel.getResSymbols()) {
            Commander.unblurSymbol(symbol);
            if (symbol.name.replace("_blur","") === "symbol_Star") {
                this.starCount++;
                switch (this.starCount) {
                    case 1:
                        this.audio.playTrack("symbol_Star_1");
                        break;
                    case 2:
                        this.audio.playTrack("symbol_Star_2");
                        break;
                    case 3:
                        this.audio.playTrack("symbol_Star_3");
                        break;
                }
                this.BlinkAnimation.blinkStar(symbol);
            }
        }

        if(!reel.data.joker && !reel.data.redJoker) {
            this.audio.playTrack("reel_Stop");
        }

    }

    brakeUp(data) {

    }


    stop(data) {
    }
}
